// extracted by mini-css-extract-plugin
export default {"brandPromo":"RG-z","carousel":"SG-z"};